import { z } from 'zod';
import { BaseApi } from '@/services/api/base-api.ts';
import zodSecomTaggingWithGateDto from '@/schemas/secom/zod-SecomTaggingWithGateDto.js';
import zodSecomTaggingSummaryDto from '@/schemas/secom/zod-SecomTaggingSummaryDto.js';

export type SecomTaggingWithGateDto = z.infer<
  typeof zodSecomTaggingWithGateDto
>;

export class SecomApi extends BaseApi {
  constructor() {
    super();
  }

  async getSummaryAsync(date: string, empNo?: number) {
    const query = empNo
      ? {
          date,
          empNo,
        }
      : { date };
    return this.requestAsync({
      schema: zodSecomTaggingSummaryDto,
      url: 'secom/tagging/date/summary',
      query,
    });
  }

  async listAsync(date: string, empNo?: number) {
    const query = empNo
      ? {
          date,
          empNo,
        }
      : { date };
    return this.requestAsync({
      schema: z.array(zodSecomTaggingWithGateDto),
      url: 'secom/tagging/date',
      query,
    });
  }
}
